module.exports = __webpack_public_path__ + "static/media/empty-cart.2a947bb8.png";